import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionButtonIcon, ActionButtonTheme } from '@nx-ng/types';

@Component({
  selector: 'nx-ng-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
})
export class ActionButtonComponent {
  @Input()
  id = '';
  @Input()
  buttonLabelKey = '';
  @Input()
  icon: ActionButtonIcon = 'none';
  @Input()
  theme: ActionButtonTheme = 'white';
  @Input()
  error = false;
  @Input()
  errorTextKey = '';
  @Input()
  disabled = false;
  @Input()
  refundAmount?: number;
  @Output()
  clicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  blur: EventEmitter<void> = new EventEmitter<void>();

  public get getTheme() {
    return `${this.theme}-theme`;
  }

  public get hasEditIcon() {
    return this.icon === 'edit';
  }

  public get hasLoadingIcon() {
    return this.icon === 'loading';
  }

  public get hasPlusIcon() {
    return this.icon === 'plus';
  }

  public get hasTickIcon() {
    return this.icon === 'tick';
  }

  public get isDisabled() {
    return this.disabled;
  }

  public get hasErrorIcon() {
    return this.error;
  }

  handleClick(): void {
    this.clicked.emit();
  }

  handleBlur(): void {
    this.blur.emit();
  }
}
